export const UserTypeLabels = {
  1: "Client",
  2: "Business Owner",
  3: "Delivery Driver",
  4: "Admin",
  5: "Delivery Company",
};

export const OrderStatusLabels = {
  1: "Pending",
  2: "Confirmed",
  3: "Preparing",
  4: "Ready for Pickup",
  5: "Out for Delivery",
  6: "Delivered",
  7: "Cancelled",
  8: "Refunded",
};

export const OrderStatusColors = {
  1: "warning",
  2: "info",
  3: "info",
  4: "secondary",
  5: "primary",
  6: "success",
  7: "error",
  8: "default",
};

// Keyed by the raw C# enum name (as returned by OrdersByStatus on the dashboard endpoint).
export const OrderStatusByName = {
  Pending: { label: "Pending", color: "warning" },
  Confirmed: { label: "Confirmed", color: "info" },
  Preparing: { label: "Preparing", color: "info" },
  ReadyForPickup: { label: "Ready for Pickup", color: "secondary" },
  OutForDelivery: { label: "Out for Delivery", color: "primary" },
  Delivered: { label: "Delivered", color: "success" },
  Cancelled: { label: "Cancelled", color: "error" },
  Refunded: { label: "Refunded", color: "default" },
};

export const DeliveryStatusLabels = {
  1: "Waiting for Driver",
  2: "Assigned",
  3: "Picked Up",
  4: "Delivered",
  5: "Failed",
};

export const DeliveryStatusColors = {
  1: "warning",
  2: "info",
  3: "primary",
  4: "success",
  5: "error",
};

export const BatchStatusLabels = {
  1: "Assigned",
  2: "In Progress",
  3: "Completed",
  4: "Cancelled",
};

export const PartnerRequestStatusLabels = {
  1: "New",
  2: "Contacted",
  3: "Approved",
  4: "Rejected",
};

export const PartnerRequestStatusColors = {
  1: "warning",
  2: "info",
  3: "success",
  4: "error",
};

export const SubscriptionStatusLabels = {
  1: "Trial",
  2: "Active",
  3: "Past Due",
  4: "Suspended",
  5: "Cancelled",
};

export const SubscriptionStatusColors = {
  1: "info",
  2: "success",
  3: "warning",
  4: "error",
  5: "default",
};

export const InvoiceStatusLabels = {
  1: "Pending",
  2: "Paid",
  3: "Overdue",
  4: "Void",
};

export const InvoiceStatusColors = {
  1: "warning",
  2: "success",
  3: "error",
  4: "default",
};

export const StoreTypeLabels = {
  1: "Retail",
  2: "Wholesale",
  3: "Retail & Wholesale",
};

export const StoreTypeColors = {
  1: "default",
  2: "secondary",
  3: "primary",
};

export const SettlementStatusLabels = {
  1: "Generated",
  2: "Paid",
};

export const SettlementStatusColors = {
  1: "warning",
  2: "success",
};

export function formatCurrency(amount) {
  const value = Number(amount ?? 0);
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "ILS",
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  return date.toLocaleString();
}
